// PROFFIT SEARCHのアップロード進捗キー
export const UPLOAD_PROGRESS_PROFFIT_SEARCH_SLIDE = 'UPLOAD_PROGRESS_PROFFIT_SEARCH_SLIDE';
export default UPLOAD_PROGRESS_PROFFIT_SEARCH_SLIDE;
